import styled from 'styled-components';

import { EditorStyled } from '@xing-com/crate-articles-article-editor';
import { scale220, spaceM, spaceXL } from '@xing-com/tokens';

export const ToolBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spaceM};
  justify-content: center;
  padding: ${spaceXL} 0;
`;

export const Container = styled.div`
  .tiptap {
    min-height: ${scale220};
    ${EditorStyled.EditorStyle}
  }
`;
